import { Transaction } from "./budgetApi.types"

export type AssetCategory = 'housing' | 'car'

export interface ExpenseEstimatesDto {
	estimates: ExpenseEstimateDto[]
}

export interface ExpenseEstimatesPostDto {
	expenseEstimateId: string
	assetId: string | null
}

export interface ExpenseEstimateDto {
	id: string
	assetId?: string | null
	possibleAssetIds: string[]
	type: ExpenseType
	monthlyAmount: number
	paymentSchedule?: PaymentScheduleDto | null
	underlyingChain?: TransactionChainDto | null
}

export interface PaymentScheduleDto {
	amount: number
	frequency: PaymentFrequencyType
}

export interface TransactionChainDto {
	transactions: Transaction[]
}

export type PaymentFrequencyType =
	(typeof PaymentFrequency)[keyof typeof PaymentFrequency]

export const PaymentFrequency = {
	Unknown: 'unknown',
	EveryMonth: 'everyMonth',
	EveryTwoWeeks: 'everyTwoWeeks',
	EveryThreeMonths: 'everyThreeMonths',
	EverySixMonths: 'everySixMonths',
	EveryYear: 'everyYear',
	EveryTwoMonths: 'everyTwoMonths',
} as const

export type ExpenseType =
	(typeof ExpenseTypeConst)[keyof typeof ExpenseTypeConst]

export const ExpenseTypeConst = {
	Unknown: 'unknown',
	Rent: 'rent',
	MortgageByBank: 'mortgageByBank',
	MortgageByCreditInstitution: 'mortgageByCreditInstitution',
	HomeLoan: 'homeLoan',
	CarLoan: 'carLoan',
	CarLeasing: 'carLeasing',

	AdditionalFixed: 'additionalFixed',
	CarMaintenanceCost: 'carMaintenanceCost',
	ChildrenInstitutions: 'childrenInstitutions',
	HousingMaintenance: 'housingMaintenance',
	HousingOther: 'housingOther',
	Insurance: 'insurance',
	MaintenanceAndChildSupport: 'maintenanceAndChildSupport',
	PhoneAndBroadband: 'phoneAndBroadband',
	PrivatePension: 'privatePension',
	TransportPublic: 'transportPublic',
	UncategorizedPaymentServices: 'uncategorizedPaymentServices',
	UnionFees: 'unionFees',
	Utilities: 'utilities',

	BankLoan: 'bankLoan',
	ConsumerLoan: 'consumerLoan',
	CreditCard: 'creditCard',
	DebtCollection: 'debtCollection',
	ForeignDebt: 'foreignDebt',
	OtherLoan: 'otherLoan',
	Overdraft: 'overdraft',
	PublicDebt: 'publicDebt',
	StudentLoan: 'studentLoan',
	UnknownLoan: 'unknownLoan',

	CooperativeHousingRent: 'cooperativeHousingRent',
	VehicleFees: 'vehicleFees',
	HomeOwnersAssociation: 'homeOwnersAssociation',
	Fuel: 'fuel',
	FixedBudgetTransfersExpense: 'fixedBudgetTransfersExpense',
	VehicleElectricCharging: 'vehicleElectricCharging',
	CarOwnershipTax: 'carOwnershipTax',
} as const